import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import portalApi from "../../lib/portalApi";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await portalApi.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") return setStatus("paid");
        if (["expired", "failed"].includes(data.payment_status)) return setStatus("failed");
      } catch { /* keep polling */ }
      if (++tries >= 10) return setStatus("timeout");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params]);

  const view = {
    checking: { icon: Loader2, title: "Confirming your payment…", text: "This only takes a moment.", spin: true },
    paid: { icon: CheckCircle2, title: "Payment received", text: "Thank you! A receipt is on its way to your email." },
    failed: { icon: XCircle, title: "Payment didn't go through", text: "No charge was made. You can try again from your portal." },
    timeout: { icon: Loader2, title: "Still processing", text: "Your payment is being confirmed. Check your portal shortly." },
  }[status];

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--mf-bg)" }} data-testid="payment-success-page">
      <div className="mf-card p-10 max-w-md w-full text-center mf-fade-in">
        <view.icon className={`w-12 h-12 mx-auto mb-4 ${view.spin ? "animate-spin" : ""}`} style={{ color: status === "failed" ? "#b91c1c" : "var(--mf-primary)" }} />
        <h1 className="font-serif text-3xl mb-2" data-testid="payment-status-title">{view.title}</h1>
        <p className="text-sm mb-6" style={{ color: "var(--mf-text-muted)" }}>{view.text}</p>
        <Link to="/portal" className="mf-btn-primary inline-block" data-testid="payment-back-portal">Back to my portal</Link>
      </div>
    </div>
  );
}
